import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "ac-form-control" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", {
  class: "subtitle my-4",
  for: "amount"
}, "Başlık", -1)
const _hoisted_3 = { class: "flex pl-2 items-center" }
const _hoisted_4 = { class: "ac-form-control" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "subtitle my-4" }, "Etkinlik Türü", -1)
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "fullDay" }, "Tüm Gün?", -1)
const _hoisted_8 = { class: "ac-form-control" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", { class: "subtitle my-4" }, "Etkinlik Zamanı", -1)
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = {
  key: 1,
  class: "date-container flex w-full justify-between gap-4"
}
const _hoisted_12 = { class: "w-2/4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", { class: "third-title pb-2 border-b border-gray-200 mr-36" }, "Başlangıç ", -1)
const _hoisted_14 = { class: "w-2/4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h3", { class: "third-title pb-2 border-b border-gray-200 mr-36" }, "Bitiş ", -1)
const _hoisted_16 = { class: "ac-form-control" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h2", {
  class: "subtitle my-4",
  for: "amount"
}, "Kategori", -1)
const _hoisted_18 = { class: "flex items-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  disabled: "",
  value: undefined
}, "Lütfen Bir Kategori Seçin", -1)
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "ac-form-control" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h2", {
  class: "subtitle my-4",
  for: "amount"
}, "Açıklama", -1)

import { ref, onBeforeMount,  } from "vue"
import { getMetas, postData, updateData} from "../../../mixins/modularFirebaseOperations"

import type { EventCategory } from "@/types"



export default /*#__PURE__*/_defineComponent({
  __name: 'addEvent',
  props: ["editedEvent"],
  emits: ["event-added", "event-updated"],
  setup(__props, { emit: __emit }) {



const eventCats = ref<EventCategory[]>([])

const emit = __emit
const props = __props


const eventName = ref(props.editedEvent?.title || "");
const eventCat = ref(props.editedEvent?.colorScheme || "");
const description = ref(props.editedEvent?.description || "");
const startDate = ref(props.editedEvent?.time.start || "");
const endDate = ref(props.editedEvent?.time.end || "");
const fullDay = ref(props.editedEvent?.fullDay || false);
const fullDayDate = ref(props.editedEvent?.fullDayDate || "");

const isLoadingEventCats = ref(false)

const manageDates = function(){
    if(fullDay.value){
        return {
            start: fullDayDate.value,
            end: fullDayDate.value
        }
    } else {
        return {
            start: startDate.value.replace("T", " "),
            end: endDate.value.replace("T", " ")
        }
    }
}

const addNewEvent = async function(){
    const newEvent = {
        title: eventName.value,
        category: eventCat.value,
        time:  manageDates(),
        description: description.value,
        isEditable: true,
    }
    if(props.editedEvent){
        newEvent.id = props.editedEvent.id
        await updateData("events", props.editedEvent.id, newEvent)
        newEvent.colorScheme = newEvent.category
        emit("event-updated", newEvent)
    } else {
        const docRefId = await postData(newEvent, "events") // Simply replace with post data.
        console.log("Document written with ID: ", docRefId);
        const newEventWithId = {id: docRefId , ...newEvent}
        emit("event-added", newEventWithId)
    }



}


onBeforeMount( async () => {
    await getMetas("metas/calendar/eventCats", eventCats.value, isLoadingEventCats)

} )


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"])),
    class: "ac-main-form"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((eventName).value = $event)),
          type: "text",
          required: "",
          class: "w-full title-field p-3"
        }, null, 512), [
          [_vModelText, eventName.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fullDay).value = $event)),
          id: "fullDay",
          type: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, fullDay.value]
        ]),
        _hoisted_7
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        (fullDay.value)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fullDayDate).value = $event)),
              type: "date",
              name: "eventDate",
              id: "eventDate",
              class: "w-full p-3"
            }, null, 512)), [
              [_vModelText, fullDayDate.value]
            ])
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((startDate).value = $event)),
                  type: "datetime-local",
                  name: "startDate",
                  id: "startDate",
                  class: "w-full p-3"
                }, null, 512), [
                  [_vModelText, startDate.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((endDate).value = $event)),
                  type: "datetime-local",
                  name: "endDate",
                  id: "endDate",
                  class: "w-full p-3"
                }, null, 512), [
                  [_vModelText, endDate.value]
                ])
              ])
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((eventCat).value = $event)),
          required: "",
          class: "w-full py-4 title-field p-3"
        }, [
          _hoisted_19,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(eventCats.value, (cat) => {
            return (_openBlock(), _createElementBlock("option", {
              key: cat.id,
              value: cat.name
            }, _toDisplayString(cat.name), 9, _hoisted_20))
          }), 128))
        ], 512), [
          [_vModelSelect, eventCat.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _hoisted_22,
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((description).value = $event)),
        type: "text",
        required: "",
        class: "w-full title-field p-3"
      }, "\n            ", 512), [
        [_vModelText, description.value]
      ])
    ]),
    _createElementVNode("button", {
      type: "button",
      onClick: addNewEvent,
      class: "ac-primary-button text-2xl mt-8"
    }, "Etkinlik Oluştur")
  ], 32))
}
}

})